import styled, { css } from 'styled-components'

const fontStyle = css`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  color: #707070;
`

const SubTitle = styled.span`
  ${fontStyle}
  line-height: calc(100vw * (19 / 375));

  & u {
    ${fontStyle}
  }
`

export default SubTitle
